import { InfoCircleFill } from 'react-bootstrap-icons';
import { useNavigate, useParams } from 'react-router-dom';

import { Button, Typography } from 'antd';

import Alert from '@/components/shared/Alert';
import { formatDate } from '@/helpers/formatDate';
import { enStatus } from '@/interfaces/course';
import { lessonsApi } from '@/services/lesson';
import styled, { StyledProp } from '@/styled';

const NotRelesed = ({ className }: StyledProp) => {
  const { id, hash } = useParams();
  const { data: lesson } = lessonsApi.endpoints.getLessons.useQueryState(id);
  const navigate = useNavigate();

  if (lesson?.status !== enStatus.NOT_RELEASED) {
    return;
  }

  const messageDate = lesson?.release ? `em ${formatDate(lesson?.release)}` : 'ainda';

  return (
    <Alert
      className={className}
      icon={<InfoCircleFill size={20} />}
      type='error'
      action={
        <Button onClick={() => navigate(`/curso/${hash}`)} type='primary' size='large'>
          Voltar para o curso
        </Button>
      }
      message='Essa aula ainda não está disponível'
      description={
        <Typography.Text>
          Essa aula será liberada {messageDate}. Para mais informações, acesse a aba
          <Typography.Text strong> Falar com o produtor</Typography.Text> na área da aula.
        </Typography.Text>
      }
    />
  );
};

export default styled(NotRelesed)``;
